import { QBankStructureLevelTag } from '@exam-management/components';
import type { QBankStructureLevelCategory } from '@exam-management/graphql';
import { Divider, Flex, Text } from '@shared/components';

export interface QBankStructureLevelItemRowHeaderProps {
  category: QBankStructureLevelCategory;
  order: number;
  name: string;
  defaultNameValue?: string;
  endAdornment?: React.ReactNode;
}

export default function QBankStructureLevelItemRowHeader(
  props: Readonly<QBankStructureLevelItemRowHeaderProps>,
) {
  const { category, order, defaultNameValue, endAdornment } = props;

  return (
    <Flex
      sx={(theme) => ({
        bgcolor: theme.palette.grey[100],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        p: theme.spacing(2.5, 3),
        height: '100%',
        alignItems: 'center',
        minHeight: '56px',
      })}
    >
      <Flex
        sx={(theme) => ({
          width: '100%',
          gap: theme.spacing(2),
          alignItems: 'center',
        })}
      >
        <QBankStructureLevelTag category={category} />

        <Text variant='body2Semibold'>{order}</Text>
        <Divider orientation='vertical' flexItem />
        <Text
          variant='body2Semibold'
          sx={{
            flexGrow: 1,
          }}
        >
          {defaultNameValue}
        </Text>
      </Flex>
      {endAdornment}
    </Flex>
  );
}
